export default "__VITE_ASSET__f90254cd__"